
import z from "zod";

export const promotionsSechma =z.object({
    title:z.string().min(1,"الاسم مطلوب"),
    type :z.string().min(1,"نوع العرض مطلوب"),
    sub_type:z.string().min(1,"النوع الفرعي مطلوب"),
   start_date:z.string().min(1,"تاريخ البداية مطلوب"),
   usage_limit_per_user:  z.preprocess(
      (val) => (val === "" ? null : Number(val)),
      z.number("عدد الاستخدامات المسموح لكل مستخدم").positive()
    ),

})   